module.exports = {
  "/": {
    "name": "index-redirect"
  },
  "/products": {
    "name": "directory",
    "success": {
      "empty state": [
        "DIRECTORY_EMPTY_STATE_LOAD"
      ],
      "grid loaded": [
        "DIRECTORY_GRID_LOAD"
      ]
    },
    "error": [
      "DIRECTORY_ERROR_LOAD"
    ]
  },
  "/products/:providerUrlToken/:goodUrlToken": {
    "name": "detail",
    "success": [
      "DETAIL_PAGE_LOAD"
    ],
    "error": [
      "DETAIL_ERROR_LOAD"
    ]
  },
  "/products/:providerUrlToken/:goodUrlToken/demo": {
    "name": "detail-demo-redirect"
  },
  "/products/:providerUrlToken/:goodUrlToken/preview": {
    "name": "detail-preview",
    "success": [
      "DETAIL_PAGE_LOAD",
      "DETAIL_PREVIEW_BANNER_LOAD"
    ],
    "error": [
      "DETAIL_ERROR_LOAD"
    ]
  },
  "/products/:providerUrlToken/:goodUrlToken/review": {
    "name": "detail-review",
    "success": [
      "DETAIL_PAGE_LOAD",
      "DETAIL_REVIEW_MODAL_LOAD"
    ],
    "error": [
      "DETAIL_ERROR_LOAD"
    ]
  },
  "/manage-purchases": {
    "name": "manage-purchases",
    "success": {
      "empty state": [
        "PURCHASES_EMPTY_STATE_LOAD"
      ],
      "table loaded": [
        "PURCHASES_TABLE_LOAD"
      ]
    },
    "error": [
      "PURCHASES_ERROR_LOAD"
    ]
  },
  "/provider-signup": {
    "name": "provider-signup",
    "success": [
      "PROVIDER_SIGNUP_LOAD"
    ]
  }
};